let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gwPQU")).then(() => parcelRequire('l5aFg'));